import { DialogService, GridAction } from '@eforall/dashboard';
import { DialogMode, Engagement } from '@interfaces';
import { BaseEngagementService } from '../../../../../services';
import { EngagementEditorDialog, EngagementEditorDialogData, EngagementViewerDialog, EngagementViewerDialogData, PersonDialog } from '../../../../widget';

export function getActions(pageService: BaseEngagementService, dialogService: DialogService) {

	const actions: GridAction<Engagement>[] = [
		{
			iconClass: 'fa-regular fa-message-arrow-up-right',
			label: 'View Engagement',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const dialogData: EngagementViewerDialogData = {
					engagementId: rows[0]!.engagementId,
					staffRoleId: pageService.staffRoleId()!
				};
				await dialogService.showCustom(EngagementViewerDialog, { data: dialogData }, 700, 700);
				await pageService.areaService?.reloadData();
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Edit Engagement',
			isEnabled: rows => !!rows.length && !!rows[0] && !rows[0].closedUTC,
			execute: async rows => {
				const dialogData: EngagementEditorDialogData = {
					mode: DialogMode.EDIT,
					engagementId: rows[0]!.engagementId,
				};
				const dialogAction = await dialogService.showCustom(EngagementEditorDialog, { data: dialogData }, 650, 800);

				// If save succeeds, callbackResult contains the updated engagementId; otherwise, it is undefined.
				if (dialogAction?.callbackResult) {
					await pageService.areaService?.reloadData();
				}
			}
		},
		{
			iconClass: 'fa-regular fa-user',
			label: 'Explore Person',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.person.id, toEdit: false } }, 800, 800);
				await pageService.areaService?.reloadData();
			}
		},
	];

	return actions;
}